import { defineComponent as s, computed as a } from "vue";
const d = /* @__PURE__ */ s({
  __name: "toggle",
  props: {
    value: { type: Boolean },
    label: { default: void 0 },
    disabled: { type: Boolean },
    medium: { type: Boolean },
    ariaLabel: { default: void 0 },
    outlinePrimary: { type: Boolean },
    normalFontSize: { type: Boolean }
  },
  emits: ["input"],
  setup(n, { expose: i, emit: t }) {
    const e = n, o = a(() => ({
      "toggle--disabled": e.disabled,
      "toggle--active": e.value,
      "toggle--medium": e.medium,
      "toggle--small-label": !e.normalFontSize
    })), r = a(() => ({
      "btn--outline-primary": e.outlinePrimary,
      "btn--outline": !e.outlinePrimary,
      "btn--disabled": e.disabled
    })), l = () => {
      e.disabled || t("input", !e.value);
    };
    return i({ containerClass: o, change: l }), { __sfc: !0, props: e, emits: t, containerClass: o, controlsClasses: r, change: l };
  }
});
export {
  d as default
};
